import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mode-field-description-editor',
  templateUrl: './field-description-editor.component.html',
  styleUrls: ['./field-description-editor.component.scss'],
})
export class FieldDescriptionEditorComponent {
  @Input() description? = '';
  @Input() readOnly = false;
  @Input() editable = false;
  @Output() editToggled = new EventEmitter<boolean>();
  @Output() updateFieldDesc = new EventEmitter<string>();

  showTextLimitWarning = false;

  toggleEditable(): void {
    if (!this.readOnly) {
      this.editable = !this.editable;
      this.editToggled.emit(this.editable);
    }
  }

  showWarning(): void {
    this.showTextLimitWarning = true;
  }

  checkForTextLimit(textLength: number): void {
    if (textLength > 350) {
      this.showTextLimitWarning = true;
    } else {
      this.showTextLimitWarning = false;
    }
  }

  sendFieldDescription(userInput: string): void {
    this.toggleEditable();
    this.showTextLimitWarning = false;
    this.updateFieldDesc.emit(userInput);
  }
}
